import React from 'react'
import ContactPage from '../Pages/ContactPage'

export default function Contact() {
  return (
    <section id="contact" className="section contact">
      <h2 className="section-title">Let's connect.</h2>
      <div className="section-content">
        <ContactPage />
      </div>
    </section>
  )
}


